(ns pfo.widget.image (:require [pfo.api :as api]
                               [reagent.core :as reagent :refer [atom]]
                               [goog.crypt.base64 :as gbase64]
                               [ajax.core :as ajax]
                               [ajax.interceptors :refer [map->ResponseFormat]]
                               [ajax.protocols :as protocol]
                               [ajax.ring :as ring]))

(defn ring-response-format [{{:keys [read description content-type]} :format}]
  (map->ResponseFormat {:read (ring/make-ring-read read)
                        :description (str "ring/" description)
                        :content-type content-type
                        :type :arraybuffer}))

(defn image-view
  ([url download-key params]
   (let [image (atom nil)]
     (ajax/POST url
                {:params (merge {:key download-key} params)
                 :format :url
                 :response-format (ring-response-format {:format {:read protocol/-body
                                                                  :type :arraybuffer}})
                 :handler (fn [response]
                            (reset! image (str
                                            "data:" (get-in response [:headers :content-type]) ";base64,"
                                            (gbase64/encodeByteArray (js/Uint8Array. (:body response))))))})
     (fn [url download-key]
       (if @image
         [:img {:src @image}]
         [:div]))))
  ([url download-key] (image-view url download-key nil)))
